import { detectHEIC } from '../common/fileReaderSupport';
import { base64ToBlob } from '../common/imageTypeConverter';
import { resizeFile } from '../common/resizeImage';
import { MAX_IMAGE_WIDTH_AND_HEIGHT } from '../constant/numericParams';

export const resizeImage = async (
  file: File,
  maxWidth = MAX_IMAGE_WIDTH_AND_HEIGHT,
  maxHeight = MAX_IMAGE_WIDTH_AND_HEIGHT
): Promise<string> => {
  return new Promise((resolve) => {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener('load', async () => {
      if (reader?.result !== null) {
        let imgFileSrc = reader?.result.toString();
        imgFileSrc = await detectHEIC(imgFileSrc);
        imgFileSrc = (await resizeFile({
          file: base64ToBlob(imgFileSrc),
          maxWidth,
          maxHeight,
          quality: 95,
          compressFormat: 'WEBP',
        })) as string;
        resolve(imgFileSrc);
      }
    });
  });
};
